import requestAction from '../../utils/requestAction'

export const fetchProductMeasurements = (params: string = "") =>
  requestAction('PRODUCTMEASUREMENT_LIST', params)(`productMeasurements`, 'GET')

export const fetchAllProductMeasurements = () =>
  fetchProductMeasurements('?all=true')